import {
  Avatar,
  Skeleton,
  SkeletonCircle,
  Stack,
  VStack,
} from "@chakra-ui/react";

import { Badge } from "@shared/ui/chakra/data-display/badge";
import { Typography } from "@shared/ui/chakra/typography/typography";

export type ProfileCardData = {
  companyLabel?: string;
  email?: string;
  name: string;
  url?: string;
  isCompany?: boolean;
};

type Props = {
  data?: ProfileCardData;
};

export const ProfileCard = ({ data }: Props) => {
  if (!data) {
    return (
      <VStack>
        <SkeletonCircle h="72px" w="72px" />
        <VStack alignItems="center" gap="1" w="50%">
          <Skeleton height="5" w="full" />
          <Skeleton height="5" width="80%" />
        </VStack>
      </VStack>
    );
  }

  return (
    <VStack>
      <Avatar.Root bg="brand.solid" color="brand.contrast" h="72px" w="72px">
        <Avatar.Fallback name={data.name} />
        <Avatar.Image src={data.url} />
      </Avatar.Root>
      {data.isCompany && (
        <Badge
          bg="bg.subtle"
          borderRadius="full"
          boxShadow="0px 4px 12px rgba(20, 20, 20, 0.08)"
          color="text.fg_accent"
          fontSize="sm"
          fontWeight="medium"
          px="2.5"
          py="1"
        >
          {data.companyLabel}
        </Badge>
      )}
      <Stack alignItems="center" gap="0">
        <Typography textStyle="title">{data.name}</Typography>
        <Typography color="text.fg_muted" textStyle="body">
          {data.email}
        </Typography>
      </Stack>
    </VStack>
  );
};
